import { Box } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import { grey } from '@mui/material/colors';
import FormControlLabel from '@mui/material/FormControlLabel';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import React, { useEffect, useState } from 'react';
import { format } from 'react-string-format';
import { constants } from '../../constants';
import useMyMApi from "../../hooks/useMyMApi";
import useWebContext from '../../hooks/useWebContext';
import { MyMButton } from '../../ui-elements/MyMButton';
import { MyMLabel } from '../../ui-elements/MyMLabel';
import { MyMProgress } from '../../ui-elements/MyMProgress';
import { mediaQuery, useMediaQuery } from '../../hooks/useMediaQuery';

/** MyMine Version1.5 UploadRequest画面新規追加
* UploadRequest Page Content
*/
export const UploadRequest = (props) => {
  const { handleModalClose } = props;
  const screenId = 'MyM205';
  const apiRequest = useMyMApi(screenId);
  const { controlSettings, messageList, screenSettings } = useWebContext(screenId);
  const [user, setUser] = React.useState(null);
  const [checked1, setChecked1] = React.useState(false);
  const [checked2, setChecked2] = React.useState(false);
  const [checked3, setChecked3] = React.useState(false);
  const [checked4, setChecked4] = React.useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const isPc = useMediaQuery(mediaQuery.pc);

  useEffect(() => {
    const callbackGetUserData = (result) => {
      setUser(result);
    }
    apiRequest.requestJson(`api/user-info/login-user`, 'GET', callbackGetUserData);
  }, []);

  const handleCheckedChange1 = (e) => {
    setChecked1(e.target.checked);
  };

  const handleCheckedChange2 = (e) => {
    setChecked2(e.target.checked);
  };

  const handleCheckedChange3 = (e) => {
    setChecked3(e.target.checked);
  };

  const handleCheckedChange4 = (e) => {
    setChecked4(e.target.checked);
  };

  const onClickBtnAgree = () => {
    const callbackUpdateRequestContext = (result) => {
      window.alert(messageList.MyM_MSG_I_0073);
      handleModalClose();
      setIsLoading(false);
    }

    const callbackFailed = () => setIsLoading(false);

    setIsLoading(true);
    const param = { ...user, StatusId: constants.UserStatus.RequestingUploader }
    apiRequest.requestJson('api/user-info/update', 'POST', callbackUpdateRequestContext, callbackFailed, param);
  }

  if (!user)
    return <MyMProgress />;

  const checkboxData = [
    { state: checked1, handler: handleCheckedChange1, label: controlSettings.LabelList.lblNotification1 },
    { state: checked2, handler: handleCheckedChange2, label: controlSettings.LabelList.lblNotification2 },
    { state: checked3, handler: handleCheckedChange3, label: controlSettings.LabelList.lblNotification3 },
    { state: checked4, handler: handleCheckedChange4, label: controlSettings.LabelList.lblNotification4 },
  ];

  return (
    <Box >
      {isLoading && <MyMProgress />}
      <MyMLabel fontSize={isPc ? "2rem" : "1.5rem"}>{controlSettings.LabelList.lblTitle}</MyMLabel>
      <Grid container>
        <Grid item xs={0.5}></Grid>
        <Grid item xs={11.5}>
          {checkboxData.map((item, index) => (
            <FormControlLabel
              key={index}
              control={
                <Checkbox
                  checked={item.state}
                  onChange={item.handler}
                  sx={{
                    color: grey[900],
                    '&.Mui-checked': {
                      color: grey[900]
                    },
                  }}
                  name={`notification${index + 1}`}
                />
              }
              label={item.label}
              sx={{
                whiteSpace: 'break-spaces',
                wordBreak: 'break-word',
                ...((!isPc && index < checkboxData.length - 1) && { marginBottom: '2em' }),
              }}
            />
          ))}
        </Grid>
      </Grid>
      <Grid container >
        <Grid item xs={1.2}></Grid>
        <Grid item xs={10.8}>
          <MyMLabel >
            {
              format(controlSettings.LabelList.lblExControlDev,
                <Link href={"mailto:" + screenSettings.ExportControlDivisionAddress} >
                  {screenSettings.ExportControlDivisionAddress}
                </Link>
              )
            }
          </MyMLabel>
        </Grid>
      </Grid>
      <Grid container mt={4}>
        <Grid item xs={5.5}>
          {checked1 && checked2 && checked3 && checked4 ?
            <MyMButton onClick={onClickBtnAgree}
              sx={{ float: 'right' }}>{controlSettings.LabelList.btnAgree}</MyMButton>
            :
            <MyMButton disabled
              sx={{ float: 'right' }}>{controlSettings.LabelList.btnAgree}</MyMButton>
          }
        </Grid>
        <Grid item xs={1}>
        </Grid>
        <Grid item xs={5.5}>
          <MyMButton onClick={handleModalClose}>{controlSettings.LabelList.btnCancel}</MyMButton>
        </Grid>
      </Grid>
    </Box>
  )
}
